module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe_alt.0f0ec1d2.png";